import './header.scss'

import type { SendMessagesParams } from '@line/liff/dist/lib/api/sendMessages'
import cls from 'classnames'
import React from 'react'

import { NoticeMessage } from '../../constants'

export interface HeaderProps {
    title: string
    className?: string
    cancelable?: boolean
    messages?: any[]
    useDefaultMessage?: boolean
}

const onCancel = (messages: SendMessagesParams) => () => {
    if (window.liff.isInClient()) {
        if (messages.length > 0) {
            window.liff
                .sendMessages(messages)
                .then(() => {
                    console.log('message sent')
                    window.liff.closeWindow()
                })
                .catch((err) => {
                    console.log('error', err)
                    window.liff.closeWindow()
                })
        }
    } else if (window.confirm(NoticeMessage.ABORTED_AUTHEN)) {
        window.close()
    }
}

const getResponseMessages = (isDefault: boolean, messages: string[]) => {
    if (messages.length > 0) return messages
    if (isDefault) return [NoticeMessage.ABORTED_AUTHEN]
    return []
}

const Header: React.FC<HeaderProps> = ({
    cancelable = true,
    title,
    className,
    messages = [],
    useDefaultMessage = true,
}) => {
    const clsHeader = cls('ui-header', className)
    const lineMessages = getResponseMessages(useDefaultMessage, messages).map<
        SendMessagesParams[0]
    >((message) => ({
        type: 'text',
        text: message,
    }))

    return (
        <header className={clsHeader}>
            <div className="abcs-container">
                <div className="hoz-layout">
                    <h4>{title}</h4>
                    {cancelable && (
                        <div
                            role="button"
                            tabIndex={0}
                            className="cancel-text"
                            onClick={onCancel(lineMessages)}
                        >
                            ยกเลิก
                        </div>
                    )}
                </div>
            </div>
        </header>
    )
}

export default Header
